module.exports = __webpack_public_path__ + "logo2.40c3145c.jpg";